(function () {
  const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function parseJsonScript(node, fallback) {
    if (!node) return fallback;

    try {
      return JSON.parse(node.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function initMobileMenu() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    const closeMenu = () => {
      toggle.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    };

    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });

    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) closeMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        closeMenu();
        toggle.focus();
      }
    });

    const desktopQuery = window.matchMedia('(min-width: 1100px)');
    const handleDesktopChange = (event) => {
      if (event.matches) closeMenu();
    };

    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', handleDesktopChange);
    }
  }

  function initFaqs() {
    document.querySelectorAll('[data-faq-list]').forEach((list) => {
      list.addEventListener('click', (event) => {
        const button = event.target.closest('[data-faq-toggle]');
        if (!button || !list.contains(button)) return;

        const item = button.closest('.bhs-faq-item');
        const answer = item && item.querySelector('.bhs-faq-item__answer');
        if (!answer) return;

        const open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
        answer.hidden = open;
      });
    });
  }

  function initHeroVideos(root) {
    const scope = root || document;

    scope.querySelectorAll('[data-hero-video]').forEach((media) => {
      if (media.dataset.heroVideoReady === 'true') return;

      const trigger = media.querySelector('[data-hero-video-trigger]');
      const video = media.querySelector('video');
      if (!trigger || !video) return;

      media.dataset.heroVideoReady = 'true';

      trigger.addEventListener('click', () => {
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });

        media.classList.add('is-video-active');
        trigger.hidden = true;
        video.hidden = false;
        video.load();

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            video.focus({ preventScroll: true });
          });
        }
      });
    });
  }

  function initFilters() {
    const toggle = document.querySelector('[data-filter-toggle]');
    const panel = document.querySelector('[data-filter-panel]');
    const submitFilterForm = (form) => {
      if (!form || form.dataset.submitting === 'true') return;

      const url = new URL(form.getAttribute('action') || window.location.href, window.location.origin);
      const params = new URLSearchParams();

      new FormData(form).forEach((value, key) => {
        if (String(value).trim() !== '') params.append(key, value);
      });

      form.dataset.submitting = 'true';
      form.setAttribute('aria-busy', 'true');
      url.search = params.toString();
      window.location.assign(url.toString());
    };

    if (toggle && panel) {
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        panel.classList.toggle('is-open', !open);
      });
    }

    document.querySelectorAll('.bhs-filter-form').forEach((form) => {
      form.addEventListener('change', (event) => {
        const field = event.target;
        if (!field.matches('[data-sort-select], input[type="checkbox"]')) return;
        submitFilterForm(form);
      });
    });
  }

  function cartEndpoint(path) {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    return root.replace(/\/?$/, '/') + path;
  }

  function normalizeDiscountCode(value) {
    return String(value || '').trim().toLowerCase();
  }

  function discountMatchesCode(discount, code) {
    const normalizedCode = normalizeDiscountCode(code);
    if (!discount || !normalizedCode) return false;

    return ['code', 'title', 'key'].some((field) => normalizeDiscountCode(discount[field]) === normalizedCode);
  }

  function cartHasDiscount(cart, code, originalDiscountTotal) {
    if (!cart) return false;
    if (Number(cart.total_discount) > Number(originalDiscountTotal || 0)) return true;

    const cartApplications = Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];
    if (cartApplications.some((discount) => discountMatchesCode(discount, code))) return true;

    return Array.isArray(cart.items) && cart.items.some((item) => {
      const discounts = [
        ...(Array.isArray(item.discounts) ? item.discounts : []),
        ...(Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations : []),
      ];

      return discounts.some((discount) => discountMatchesCode(discount, code));
    });
  }

  function initCartDiscounts() {
    const discountStorageKey = 'bhsDiscountCode';

    document.querySelectorAll('[data-cart-discount]').forEach((root) => {
      if (root.dataset.cartDiscountReady === 'true') return;

      const input = root.querySelector('[data-cart-discount-input]');
      const hiddenInput = root.querySelector('[data-cart-discount-hidden]');
      const applyButton = root.querySelector('[data-cart-discount-apply]');
      const message = root.querySelector('[data-cart-discount-message]');
      if (!input || !applyButton || !message) return;

      root.dataset.cartDiscountReady = 'true';
      const originalDiscountTotal = Number(root.getAttribute('data-original-discount-total')) || 0;
      const appliedDiscountCode = root.getAttribute('data-applied-discount-code') || '';
      const rememberedDiscountCode = window.sessionStorage
        ? window.sessionStorage.getItem(discountStorageKey) || ''
        : '';
      const activeDiscountCode = appliedDiscountCode || (originalDiscountTotal > 0 ? rememberedDiscountCode : '');

      if (activeDiscountCode && !input.value) input.value = activeDiscountCode;

      function syncCheckoutDiscount() {
        if (!hiddenInput) return;

        const code = input.value.trim();
        hiddenInput.value = code;
        hiddenInput.disabled = code === '';
      }

      function setMessage(text, state) {
        message.textContent = text;
        message.classList.toggle('is-error', state === 'error');
        message.classList.toggle('is-success', state === 'success');
      }

      async function applyDiscount() {
        const code = input.value.trim();
        if (!code) {
          setMessage('Enter a promo code first.', 'error');
          input.focus();
          return;
        }

        applyButton.disabled = true;
        applyButton.setAttribute('aria-busy', 'true');
        setMessage('Applying promo code...', 'success');

        try {
          const response = await fetch(cartEndpoint('cart/update.js'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ discount: code }),
          });
          const cart = await response.json().catch(() => null);

          if (!response.ok) {
            throw new Error(cart && cart.description ? cart.description : 'Cart update failed');
          }

          if (cartHasDiscount(cart, code, originalDiscountTotal)) {
            if (window.sessionStorage) window.sessionStorage.setItem(discountStorageKey, code);
            if (hiddenInput) {
              hiddenInput.value = code;
              hiddenInput.disabled = false;
            }
            setMessage('Promo code applied. Refreshing cart...', 'success');
            window.location.reload();
            return;
          }

          setMessage('That code was not applied to this cart.', 'error');
        } catch (_error) {
          setMessage('We could not apply that code. Please try it again at checkout.', 'error');
        } finally {
          applyButton.disabled = false;
          applyButton.removeAttribute('aria-busy');
        }
      }

      applyButton.addEventListener('click', applyDiscount);
      input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        applyDiscount();
      });

      input.addEventListener('input', syncCheckoutDiscount);
      syncCheckoutDiscount();
    });
  }

  function initCartForms() {
    document.querySelectorAll('[data-cart-form]').forEach((form) => {
      if (form.dataset.cartFormReady === 'true') return;
      form.dataset.cartFormReady = 'true';

      form.addEventListener('submit', (event) => {
        const submitter = event.submitter || document.activeElement;
        if (!submitter || !submitter.matches('[data-cart-checkout-button]')) return;

        form.querySelectorAll('[data-cart-discount]').forEach((root) => {
          const input = root.querySelector('[data-cart-discount-input]');
          const hiddenInput = root.querySelector('[data-cart-discount-hidden]');
          if (!input || !hiddenInput) return;

          const code = input.value.trim();
          hiddenInput.value = code;
          hiddenInput.disabled = code === '';
        });
      });
    });
  }

  function initProductGallery(section) {
    const main = section.querySelector('[data-gallery-main]');
    const data = section.querySelector('[data-gallery-json]');
    if (!main || !data) return;

    let media = [];
    try {
      media = JSON.parse(data.textContent || '[]');
    } catch (_error) {
      media = [];
    }

    section.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.getAttribute('data-media-index'));
        const item = media[index];
        if (!item || item.type !== 'image') return;

        main.querySelectorAll('img, video, model-viewer, iframe').forEach((node) => node.remove());
        const image = document.createElement('img');
        image.src = item.src;
        image.alt = item.alt || '';
        image.loading = 'eager';
        main.prepend(image);

        section.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });
  }

  function selectedOptions(form) {
    return Array.from(form.querySelectorAll('[data-option-input]:checked')).map((input) => input.value);
  }

  function findVariant(variants, options) {
    return variants.find((variant) => {
      return options.every((option, index) => variant.options[index] === option);
    });
  }

  function updateProductForm(section) {
    const form = section.querySelector('.bhs-product-form');
    if (!form) return;

    const variantScript = form.querySelector('[data-variant-json]');
    const idInput = form.querySelector('[data-variant-id]');
    const addButton = form.querySelector('[data-add-button]');
    const addButtonText = form.querySelector('[data-add-button-text]');
    const priceTarget = section.querySelector('[data-product-price]');
    const skuTarget = section.querySelector('[data-variant-sku]');
    const stockTarget = section.querySelector('[data-variant-stock]');

    let variants = [];
    try {
      variants = JSON.parse(variantScript ? variantScript.textContent : '[]');
    } catch (_error) {
      variants = [];
    }

    function sync() {
      const options = selectedOptions(form);
      const variant = findVariant(variants, options) || variants[0];
      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      if (priceTarget) {
        const compare = variant.compare_at_price && variant.compare_at_price > variant.price
          ? '<span class="bhs-price__compare">' + formatMoney(variant.compare_at_price) + '</span>'
          : '';
        priceTarget.innerHTML = '<div class="bhs-price">' + compare + '<span class="bhs-price__current">' + formatMoney(variant.price) + '</span></div>';
      }

      if (skuTarget) skuTarget.textContent = variant.sku || '';

      if (stockTarget) {
        stockTarget.textContent = variant.available ? 'In Stock' : 'Sold Out';
        stockTarget.classList.toggle('is-in', variant.available);
        stockTarget.classList.toggle('is-out', !variant.available);
      }

      if (addButton) addButton.disabled = !variant.available;
      if (addButtonText) addButtonText.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }

    form.querySelectorAll('[data-option-input]').forEach((input) => input.addEventListener('change', sync));
    sync();
  }

  function initFindMyEnclosure() {
    document.querySelectorAll('[data-find-enclosure]').forEach((root) => {
      const sourceUrl = root.getAttribute('data-source-url');
      const stepper = root.querySelector('[data-finder-stepper]');
      const status = root.querySelector('[data-finder-status]');
      const content = root.querySelector('[data-finder-content]');
      const brandAssets = parseJson(root.querySelector('[data-finder-brand-assets]'), []);
      const sizeOptions = parseJson(root.querySelector('[data-finder-size-options]'), []);
      const brandOrder = brandAssets.map((asset) => normalizeKey(asset.name));
      const brandLogoByKey = new Map(brandAssets.map((asset) => [normalizeKey(asset.name), asset.url]));
      const sizeOptionByKey = new Map(sizeOptions.map((size) => [normalizeSize(size.value || size.label), size]));
      const nonSeriesTagKeys = new Set([
        'subwoofer-boxes',
        'ported-enclosure',
        'sealed-enclosure',
        'birch-ply',
        'mdf',
        'stained',
        'raw-birch',
        'unfinished',
        'bedliner',
        'black-bedliner'
      ]);

      let products = [];
      const state = {
        step: 1,
        selectedBrand: null,
        selectedSeries: null,
        seriesQuery: ''
      };

      function parseJson(node, fallback) {
        if (!node) return fallback;
        try {
          return JSON.parse(node.textContent || '');
        } catch (_error) {
          return fallback;
        }
      }

      function escapeHtml(value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      function normalizeKey(value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/&/g, 'and')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      function normalizeSize(value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/"/g, '')
          .replace(/\s*inches?\b/g, '')
          .replace(/[^0-9.]/g, '');
      }

      function escapeRegExp(value) {
        return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }

      function normalizeTags(product) {
        return Array.isArray(product.tags) ? product.tags.filter(Boolean).map(String) : [];
      }

      function matchingBrandTag(tags, name) {
        const key = normalizeKey(name);
        return tags.find((tag) => normalizeKey(tag) === key) || '';
      }

      function inferBrand(product, tags) {
        if (product.brand) {
          return {
            name: product.brand,
            tag: matchingBrandTag(tags, product.brand)
          };
        }

        const tag = tags.find((item) => brandOrder.includes(normalizeKey(item)));
        if (tag) {
          const asset = brandAssets.find((item) => normalizeKey(item.name) === normalizeKey(tag));
          return {
            name: asset ? asset.name : tag,
            tag
          };
        }

        const vendor = String(product.vendor || '').trim();
        if (vendor && normalizeKey(vendor) !== 'basshead-supply') {
          return {
            name: vendor,
            tag: matchingBrandTag(tags, vendor)
          };
        }

        return { name: '', tag: '' };
      }

      function inferSize(product, tags) {
        if (product.size) return product.size;

        const sizeTag = tags.find((tag) => sizeOptionByKey.has(normalizeSize(tag)));
        if (sizeTag) {
          const option = sizeOptionByKey.get(normalizeSize(sizeTag));
          return option.value || option.label || sizeTag;
        }

        const collections = Array.isArray(product.collections) ? product.collections : [];
        const collection = collections.find((item) => {
          return sizeOptions.some((size) => size.handle && size.handle === item.handle);
        });
        if (collection) {
          const option = sizeOptions.find((size) => size.handle === collection.handle);
          return option.value || option.label || '';
        }

        const titleMatch = String(product.title || '').match(/(?:^|\s)(6\.5|8|10|12|13\.5|15|18)\s*(?:"|inch|in\b)/i);
        if (titleMatch) {
          const option = sizeOptionByKey.get(normalizeSize(titleMatch[1]));
          return option ? option.value || option.label : titleMatch[1] + ' inch';
        }

        return '';
      }

      function isMetadataTag(tag, brand) {
        const key = normalizeKey(tag);
        const text = String(tag || '').trim().toLowerCase();

        if (!key) return true;
        if (brand.name && key === normalizeKey(brand.name)) return true;
        if (brandOrder.includes(key)) return true;
        if (sizeOptionByKey.has(normalizeSize(tag))) return true;
        if (/^\d+$/.test(text)) return true;
        if (/^\d+(?:\.\d+)?\s*cu\b/.test(text)) return true;
        if (/^\d+(?:\.\d+)?\s*hz\b/.test(text)) return true;
        if (text.includes('subwoofer boxes')) return true;
        if (nonSeriesTagKeys.has(key)) return true;

        return false;
      }

      function inferSeries(product, tags, brand) {
        if (product.series) {
          return {
            name: product.series,
            tag: matchingBrandTag(tags, product.series)
          };
        }

        const tag = tags.find((item) => !isMetadataTag(item, brand));
        if (tag) return { name: tag, tag };

        let series = String(product.title || '').trim();
        if (brand.name) {
          series = series.replace(new RegExp('\\b' + escapeRegExp(brand.name) + '\\b', 'i'), '');
        }

        series = series
          .replace(/\b(single|dual|triple|quad)\b/gi, '')
          .replace(/\b(6\.5|8|10|12|13\.5|15|18)\s*(?:"|inch|in\b)?/gi, '')
          .replace(/\b(ported|sealed)\s+enclosure\b/gi, '')
          .replace(/\b(subwoofer|speaker|box|boxes|enclosure)\b/gi, '')
          .replace(/\s+/g, ' ')
          .trim();

        return { name: series, tag: '' };
      }

      function countLabel(count, singular, plural) {
        return count + ' ' + (count === 1 ? singular : plural);
      }

      function pageUrl(page) {
        const url = new URL(sourceUrl || '/collections/subwoofer-boxes?view=finder-data', window.location.origin);
        url.searchParams.set('page', String(page));
        return url.toString();
      }

      async function fetchPage(page) {
        const response = await fetch(pageUrl(page), {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        if (!response.ok) throw new Error('Finder data request failed');
        return response.json();
      }

      async function loadProducts() {
        const firstPage = await fetchPage(1);
        const pages = Math.max(1, Number(firstPage.pages || 1));
        const records = Array.isArray(firstPage.products) ? firstPage.products.slice() : [];

        if (pages > 1) {
          const laterPages = [];
          for (let page = 2; page <= pages; page += 1) laterPages.push(fetchPage(page));
          const results = await Promise.all(laterPages);
          results.forEach((result) => {
            if (Array.isArray(result.products)) records.push(...result.products);
          });
        }

        products = records
          .map((product) => {
            const tags = normalizeTags(product);
            const brand = inferBrand(product, tags);
            const size = inferSize(product, tags);
            const series = inferSeries(product, tags, brand);

            return {
              title: product.title || '',
              handle: product.handle || '',
              brand: brand.name,
              brandKey: normalizeKey(brand.name),
              brandTag: brand.tag,
              series: series.name,
              seriesKey: normalizeKey(series.name),
              seriesTag: series.tag,
              size,
              sizeKey: normalizeSize(size),
              available: Boolean(product.available)
            };
          })
          .filter((product) => product.brand && product.size);
      }

      function getBrands() {
        const map = new Map();
        products.forEach((product) => {
          if (!map.has(product.brandKey)) {
            map.set(product.brandKey, {
              key: product.brandKey,
              name: product.brand,
              count: 0,
              filterTag: product.brandTag || '',
              logo: brandLogoByKey.get(product.brandKey) || ''
            });
          }
          if (!map.get(product.brandKey).filterTag && product.brandTag) {
            map.get(product.brandKey).filterTag = product.brandTag;
          }
          map.get(product.brandKey).count += 1;
        });

        return Array.from(map.values()).sort((a, b) => {
          const aIndex = brandOrder.indexOf(a.key);
          const bIndex = brandOrder.indexOf(b.key);
          if (aIndex !== -1 || bIndex !== -1) {
            if (aIndex === -1) return 1;
            if (bIndex === -1) return -1;
            return aIndex - bIndex;
          }
          return a.name.localeCompare(b.name);
        });
      }

      function getSeriesForBrand() {
        if (!state.selectedBrand) return [];
        const map = new Map();
        products.forEach((product) => {
          if (product.brandKey !== state.selectedBrand.key || !product.series) return;
          if (!map.has(product.seriesKey)) {
            map.set(product.seriesKey, {
              key: product.seriesKey,
              name: product.series,
              filterTag: product.seriesTag || '',
              count: 0
            });
          }
          if (!map.get(product.seriesKey).filterTag && product.seriesTag) {
            map.get(product.seriesKey).filterTag = product.seriesTag;
          }
          map.get(product.seriesKey).count += 1;
        });

        return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name));
      }

      function productsForCurrentSelection() {
        return products.filter((product) => {
          if (!state.selectedBrand || product.brandKey !== state.selectedBrand.key) return false;
          if (state.selectedSeries && product.seriesKey !== state.selectedSeries.key) return false;
          return true;
        });
      }

      function getSizesForSelection() {
        const selectedProducts = productsForCurrentSelection();
        return sizeOptions.map((size) => {
          const sizeKey = normalizeSize(size.value || size.label);
          const count = selectedProducts.filter((product) => product.sizeKey === sizeKey).length;
          return {
            label: size.label || size.handle,
            value: size.value || '',
            handle: size.handle || '',
            url: size.url || ('/collections/' + size.handle),
            key: sizeKey,
            count
          };
        });
      }

      function renderStepper() {
        const hasSeries = state.selectedBrand && getSeriesForBrand().length > 0;
        const steps = hasSeries
          ? [
              { number: '01', label: 'Brand', step: 1 },
              { number: '02', label: 'Series', step: 2 },
              { number: '03', label: 'Size', step: 3 }
            ]
          : [
              { number: '01', label: 'Brand', step: 1 },
              { number: '02', label: 'Size', step: 3 }
            ];

        stepper.innerHTML = steps.map((item, index) => {
          const spacer = index < steps.length - 1 ? '<i aria-hidden="true"></i>' : '';
          const active = state.step === item.step ? ' class="is-active"' : '';
          return '<span' + active + '>' + item.number + ' &nbsp; ' + item.label + '</span>' + spacer;
        }).join('');
      }

      function renderBrandStep() {
        const brands = getBrands();
        return [
          '<div class="bhs-finder-heading-row"><h2>Which subwoofer brand?</h2></div>',
          '<div class="bhs-finder-grid">',
          brands.map((brand) => {
            const logo = brand.logo
              ? '<img src="' + escapeHtml(brand.logo) + '" alt="' + escapeHtml(brand.name) + '" loading="lazy">'
              : '';
            return [
              '<button class="bhs-finder-card bhs-finder-brand-card" type="button" data-finder-action="brand" data-key="' + escapeHtml(brand.key) + '">',
              logo,
              '<strong>' + escapeHtml(brand.name) + '</strong>',
              '<small>' + countLabel(brand.count, 'product', 'products') + '</small>',
              '</button>'
            ].join('');
          }).join(''),
          '</div>'
        ].join('');
      }

      function renderSeriesStep() {
        const seriesList = getSeriesForBrand();
        const query = state.seriesQuery.trim().toLowerCase();
        const visibleSeries = query
          ? seriesList.filter((series) => series.name.toLowerCase().includes(query))
          : seriesList;

        return [
          '<div class="bhs-finder-heading-row">',
          '<h2>Which model series?</h2>',
          '<div class="bhs-finder-pill"><span>Brand</span><strong>' + escapeHtml(state.selectedBrand.name) + '</strong><button type="button" data-finder-action="reset-brand">Change</button></div>',
          '</div>',
          seriesList.length > 8
            ? '<div class="bhs-finder-search"><input type="search" value="' + escapeHtml(state.seriesQuery) + '" placeholder="Search series..." data-finder-series-search></div>'
            : '',
          '<div class="bhs-finder-grid bhs-finder-grid--options">',
          '<button class="bhs-finder-card bhs-finder-option-card" type="button" data-finder-action="series-any"><strong>Any Series</strong><small>Show all ' + escapeHtml(state.selectedBrand.name) + ' enclosures</small><em>Skip &rarr;</em></button>',
          visibleSeries.map((series) => [
            '<button class="bhs-finder-card bhs-finder-option-card" type="button" data-finder-action="series" data-key="' + escapeHtml(series.key) + '">',
            '<strong>' + escapeHtml(series.name) + '</strong>',
            '<small>' + countLabel(series.count, 'enclosure', 'enclosures') + '</small>',
            '<em>Select &rarr;</em>',
            '</button>'
          ].join('')).join(''),
          visibleSeries.length === 0 ? '<div class="bhs-finder-empty">No series match "' + escapeHtml(state.seriesQuery) + '".</div>' : '',
          '</div>'
        ].join('');
      }

      function renderSizeStep() {
        const sizes = getSizesForSelection();
        const hasSeries = getSeriesForBrand().length > 0;

        return [
          '<div class="bhs-finder-heading-row">',
          '<h2>What size?</h2>',
          '<div class="bhs-finder-pill"><span>Brand</span><strong>' + escapeHtml(state.selectedBrand.name) + '</strong><button type="button" data-finder-action="reset-brand">Change</button></div>',
          state.selectedSeries
            ? '<div class="bhs-finder-pill"><span>Series</span><strong>' + escapeHtml(state.selectedSeries.name) + '</strong><button type="button" data-finder-action="reset-series">Change</button></div>'
            : '',
          !state.selectedSeries && hasSeries
            ? '<button class="bhs-finder-link-button" type="button" data-finder-action="reset-series">+ Pick a series</button>'
            : '',
          '</div>',
          '<div class="bhs-finder-grid bhs-finder-grid--options">',
          sizes.map((size) => [
            '<button class="bhs-finder-card bhs-finder-option-card" type="button" data-finder-action="size" data-key="' + escapeHtml(size.key) + '" ' + (size.count === 0 ? 'disabled' : '') + '>',
            '<strong>' + escapeHtml(size.label) + '</strong>',
            '<small>' + (size.count === 0 ? 'No matches' : countLabel(size.count, 'match', 'matches')) + '</small>',
            '<em>See matches &rarr;</em>',
            '</button>'
          ].join('')).join(''),
          '</div>'
        ].join('');
      }

      function render() {
        renderStepper();
        if (!content) return;

        if (state.step === 1) content.innerHTML = renderBrandStep();
        if (state.step === 2) content.innerHTML = renderSeriesStep();
        if (state.step === 3) content.innerHTML = renderSizeStep();
        content.hidden = false;
      }

      function scrollToFinder() {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function goToMatches(size) {
        const url = new URL(size.url || ('/collections/' + size.handle), window.location.origin);
        const tagFilters = [
          state.selectedBrand && state.selectedBrand.filterTag,
          state.selectedSeries && state.selectedSeries.filterTag
        ].filter(Boolean).map(normalizeKey);

        if (tagFilters.length > 0) {
          url.pathname = url.pathname.replace(/\/$/, '') + '/' + tagFilters.join('+');
          url.search = '';
        } else {
          url.searchParams.set('filter.p.m.custom.brand', state.selectedBrand.name);
        }

        if (state.selectedSeries && tagFilters.length === 0) {
          url.searchParams.set('filter.p.m.custom.model_series', state.selectedSeries.name);
        }
        window.location.assign(url.pathname + url.search);
      }

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-finder-action]');
        if (!button || !root.contains(button)) return;

        const action = button.getAttribute('data-finder-action');
        const key = button.getAttribute('data-key');

        if (action === 'brand') {
          const brand = getBrands().find((item) => item.key === key);
          if (!brand) return;
          state.selectedBrand = brand;
          state.selectedSeries = null;
          state.seriesQuery = '';
          state.step = getSeriesForBrand().length > 0 ? 2 : 3;
          render();
          scrollToFinder();
        }

        if (action === 'series') {
          const series = getSeriesForBrand().find((item) => item.key === key);
          if (!series) return;
          state.selectedSeries = series;
          state.step = 3;
          render();
          scrollToFinder();
        }

        if (action === 'series-any') {
          state.selectedSeries = null;
          state.step = 3;
          render();
          scrollToFinder();
        }

        if (action === 'size') {
          const size = getSizesForSelection().find((item) => item.key === key);
          if (!size || size.count === 0) return;
          goToMatches(size);
        }

        if (action === 'reset-brand') {
          state.step = 1;
          state.selectedBrand = null;
          state.selectedSeries = null;
          state.seriesQuery = '';
          render();
        }

        if (action === 'reset-series') {
          state.step = 2;
          state.selectedSeries = null;
          render();
        }
      });

      root.addEventListener('input', (event) => {
        const input = event.target.closest('[data-finder-series-search]');
        if (!input) return;
        const cursor = input.selectionStart;
        state.seriesQuery = input.value;
        render();
        const nextInput = root.querySelector('[data-finder-series-search]');
        if (nextInput) {
          nextInput.focus();
          nextInput.setSelectionRange(cursor, cursor);
        }
      });

      if (!sourceUrl || !stepper || !status || !content) return;

      loadProducts()
        .then(() => {
          if (products.length === 0) {
            status.textContent = 'No enclosure products are available for the finder yet.';
            return;
          }
          status.hidden = true;
          render();
        })
        .catch(() => {
          status.textContent = 'We could not load the enclosure finder data. Please refresh the page or contact us for help.';
        });
    });
  }

  function initKitFilters(root) {
    const scope = root || document;
    const pages = [];

    if (scope.matches && scope.matches('[data-kit-page]')) pages.push(scope);
    pages.push(...scope.querySelectorAll('[data-kit-page]'));

    pages.forEach((page) => {
      if (page.dataset.kitFiltersReady === 'true') return;

      const filterPanel = page.querySelector('[data-kit-filters]');
      const grid = page.querySelector('.bhs-kit-grid');
      const cards = Array.from(page.querySelectorAll('[data-kit-card]'));
      if (!filterPanel || !grid || cards.length === 0) return;

      cards
        .sort((left, right) => {
          const orderDifference = (Number(left.dataset.kitSort) || 1000) - (Number(right.dataset.kitSort) || 1000);
          return orderDifference || String(left.dataset.kitTitle || '').localeCompare(String(right.dataset.kitTitle || ''));
        })
        .forEach((card) => grid.appendChild(card));

      page.dataset.kitFiltersReady = 'true';
      if (cards.length < 2) return;

      const selects = Array.from(filterPanel.querySelectorAll('[data-kit-filter]'));
      const resetButton = filterPanel.querySelector('[data-kit-filter-reset]');
      const result = filterPanel.querySelector('[data-kit-filter-result]');
      const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

      selects.forEach((select) => {
        const field = select.getAttribute('data-kit-filter');
        const values = Array.from(new Set(cards.map((card) => card.dataset['kit' + field.charAt(0).toUpperCase() + field.slice(1)] || '').filter(Boolean)))
          .sort(collator.compare);

        values.forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = field === 'count' ? value + (value === '1' ? ' subwoofer' : ' subwoofers') : value;
          select.appendChild(option);
        });

        if (field === 'brand' && values.length === 1) {
          select.value = values[0];
          select.disabled = true;
        }
      });

      function applyKitFilters() {
        const active = selects.reduce((filters, select) => {
          const value = select.value.trim().toLowerCase();
          if (value) filters[select.getAttribute('data-kit-filter')] = value;
          return filters;
        }, {});
        const brandSelect = selects.find((select) => select.getAttribute('data-kit-filter') === 'brand');
        const seriesSelect = selects.find((select) => select.getAttribute('data-kit-filter') === 'series');
        const prompt = brandSelect && !brandSelect.value
          ? 'Choose a brand to see approved kits.'
          : seriesSelect && !seriesSelect.value
            ? 'Choose a series to see approved kits.'
            : '';
        let visibleCount = 0;

        cards.forEach((card) => {
          const matches = !prompt && Object.entries(active).every(([field, value]) => {
            const key = 'kit' + field.charAt(0).toUpperCase() + field.slice(1);
            return String(card.dataset[key] || '').trim().toLowerCase() === value;
          });
          card.hidden = !matches;
          if (!matches) card.classList.remove('is-mobile-active');
          if (matches) visibleCount += 1;
        });

        const hasUserFilters = selects.some((select) => !select.disabled && select.value);
        if (resetButton) resetButton.hidden = !hasUserFilters;
        if (result) {
          result.textContent = prompt || (visibleCount === 0
            ? 'No approved kits match those filters yet.'
            : visibleCount + (visibleCount === 1 ? ' matched kit' : ' matched kits'));
        }
      }

      selects.forEach((select) => select.addEventListener('change', applyKitFilters));
      if (resetButton) {
        resetButton.addEventListener('click', () => {
          selects.forEach((select) => {
            if (!select.disabled) select.value = '';
          });
          applyKitFilters();
        });
      }

      filterPanel.hidden = false;
      applyKitFilters();
    });
  }

  function initKitPages(root) {
    const scope = root || document;
    const cards = [];

    initKitFilters(scope);

    if (scope.matches && scope.matches('[data-kit-card]')) cards.push(scope);
    cards.push(...scope.querySelectorAll('[data-kit-card]'));

    cards.forEach((card) => {
      if (card.dataset.kitReady === 'true') return;

      const components = Array.from(card.querySelectorAll('[data-kit-component]')).map((element) => ({
        element,
        key: element.getAttribute('data-kit-component') || 'component',
        label: element.getAttribute('data-kit-component-label') || 'Component',
        quantity: Math.max(1, Number.parseInt(element.getAttribute('data-kit-component-quantity') || '1', 10) || 1),
        product: parseJsonScript(element.querySelector('[data-kit-product-json]'), { variants: [] }),
        discountPercent: Math.min(100, Math.max(0, Number(element.getAttribute('data-kit-discount-percent')) || 0)),
        optionGroups: Array.from(element.querySelectorAll('[data-kit-option-group]')),
        optionInputs: Array.from(element.querySelectorAll('[data-kit-option-input]')),
        priceElement: element.querySelector('[data-kit-price]'),
        comparePriceElement: element.querySelector('[data-kit-compare-price]'),
        discountLabelElement: element.querySelector('[data-kit-discount-label]'),
        skuElement: element.querySelector('[data-kit-sku]'),
        availabilityElement: element.querySelector('[data-kit-availability]'),
      }));
      components.forEach((component) => {
        component.summaryPriceElement = card.querySelector('[data-kit-summary-price="' + component.key + '"]');
        component.summaryCompareElement = card.querySelector('[data-kit-summary-compare="' + component.key + '"]');
      });
      const quantityInput = card.querySelector('[data-kit-quantity]');
      const totalElement = card.querySelector('[data-kit-total]');
      const mobileTotalElement = card.querySelector('[data-kit-mobile-total]');
      const savingsElement = card.querySelector('[data-kit-savings]');
      const badgeSavingsElement = card.querySelector('[data-kit-badge-savings]');
      const addButtons = Array.from(card.querySelectorAll('[data-kit-add]'));
      const status = card.querySelector('[data-kit-status]');
      const buttonLabel = card.getAttribute('data-kit-button-label') || (addButtons[0] ? addButtons[0].textContent.trim() : 'Add kit to cart');

      if (addButtons.length === 0 || components.length === 0) return;
      card.dataset.kitReady = 'true';

      function selectedQuantity() {
        const value = Number.parseInt(quantityInput ? quantityInput.value : '1', 10);
        return Number.isFinite(value) ? value : 0;
      }

      function selectedVariant(component) {
        const variants = component.product && Array.isArray(component.product.variants)
          ? component.product.variants
          : [];
        if (variants.length === 0) return null;
        if (component.optionGroups.length === 0) return variants[0];

        const selected = [];
        component.optionGroups.forEach((group) => {
          const position = Number.parseInt(group.getAttribute('data-position') || '0', 10);
          const checked = group.querySelector('[data-kit-option-input]:checked');
          if (position > 0) selected[position - 1] = checked ? checked.value : null;
        });

        return variants.find((variant) => {
          const options = Array.isArray(variant.options) ? variant.options : [];
          return selected.every((value, index) => value === null || String(options[index]) === String(value));
        }) || null;
      }

      function currentSelections() {
        return components.map((component) => ({
          component,
          variant: selectedVariant(component),
        }));
      }

      function discountedPrice(component, variant) {
        const price = Number(variant && variant.price ? variant.price : 0);
        const discountAmount = Math.floor(price * component.discountPercent / 100);
        return {
          discountAmount,
          price: price - discountAmount,
          regularPrice: price,
        };
      }

      function sync() {
        const quantity = selectedQuantity();
        const selections = currentSelections();
        let total = 0;
        let savings = 0;
        let hasUnavailable = quantity < 1;

        selections.forEach(({ component, variant }) => {
          if (!variant) {
            hasUnavailable = true;
          } else {
            const componentPrice = discountedPrice(component, variant);
            total += componentPrice.price * component.quantity;
            savings += componentPrice.discountAmount * component.quantity;
            hasUnavailable = hasUnavailable || !variant.available;
          }

          if (component.priceElement) {
            const componentPrice = discountedPrice(component, variant);
            component.priceElement.textContent = variant ? formatMoney(componentPrice.price) : '-';
            if (component.comparePriceElement) {
              component.comparePriceElement.textContent = variant ? formatMoney(componentPrice.regularPrice) : '';
              component.comparePriceElement.hidden = !variant || component.discountPercent <= 0;
            }
            if (component.discountLabelElement) {
              component.discountLabelElement.textContent = 'Kit price';
              component.discountLabelElement.hidden = !variant || component.discountPercent <= 0;
            }
            if (component.summaryPriceElement) {
              component.summaryPriceElement.textContent = variant ? formatMoney(componentPrice.price * component.quantity) : '-';
            }
            if (component.summaryCompareElement) {
              component.summaryCompareElement.textContent = variant ? formatMoney(componentPrice.regularPrice * component.quantity) : '';
              component.summaryCompareElement.hidden = !variant || component.discountPercent <= 0;
            }
          }
          if (component.skuElement) {
            component.skuElement.textContent = variant && variant.sku ? 'SKU: ' + variant.sku : '';
          }
          if (component.availabilityElement) {
            component.availabilityElement.textContent = variant && variant.available ? 'Available' : 'Unavailable';
          }
        });

        const effectiveQuantity = Math.max(quantity, 1);
        const formattedTotal = formatMoney(total * effectiveQuantity);
        if (totalElement) totalElement.textContent = formattedTotal;
        if (mobileTotalElement) mobileTotalElement.textContent = formattedTotal;
        if (savingsElement) savingsElement.textContent = formatMoney(savings * effectiveQuantity);
        if (badgeSavingsElement) badgeSavingsElement.textContent = formatMoney(savings * effectiveQuantity);
        addButtons.forEach((button) => {
          const includePrice = button.getAttribute('data-kit-button-price') !== 'false';
          button.disabled = hasUnavailable;
          button.textContent = includePrice ? buttonLabel + ' — ' + formattedTotal : buttonLabel;
        });
      }

      function clearStatusAndSync() {
        if (status) status.textContent = '';
        sync();
      }

      components.forEach((component) => {
        component.optionInputs.forEach((input) => {
          input.addEventListener('change', clearStatusAndSync);
        });
      });

      if (quantityInput) {
        quantityInput.addEventListener('input', clearStatusAndSync);
        quantityInput.addEventListener('change', clearStatusAndSync);
      }

      function addKitToCart() {
        const quantity = selectedQuantity();
        const selections = currentSelections();
        const unavailableSelection = selections.find(({ variant }) => !variant || !variant.available);

        if (quantity < 1) {
          if (status) status.textContent = 'Enter a quantity of 1 or more.';
          sync();
          return;
        }

        if (unavailableSelection) {
          if (status) status.textContent = 'One of the selected kit items is unavailable.';
          sync();
          return;
        }

        const kitTitle = card.getAttribute('data-kit-title') || 'Bass package';
        const kitId = card.getAttribute('data-kit-id') || kitTitle;
        const items = selections.map(({ component, variant }) => ({
          id: variant.id,
          quantity: quantity * component.quantity,
          properties: {
            Kit: kitTitle,
            'Kit Component': component.label,
            _kit_id: kitId,
          },
        }));

        addButtons.forEach((button) => {
          button.disabled = true;
          button.textContent = 'Adding...';
        });
        if (status) status.textContent = 'Adding kit to cart...';

        fetch(cartEndpoint('cart/add.js'), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items }),
        })
          .then((response) => {
            if (response.ok) return response.json();
            return response.json().catch(() => ({})).then((error) => Promise.reject(error));
          })
          .then(() => {
            if (status) status.textContent = 'Kit added to cart.';
            if (card.getAttribute('data-kit-redirect') === 'true') {
              window.location.assign(cartEndpoint('cart'));
            }
          })
          .catch((error) => {
            const message = error && (error.description || error.message)
              ? error.description || error.message
              : 'We could not add this kit. Please try again.';
            if (status) status.textContent = message;
          })
          .finally(() => {
            sync();
          });
      }

      addButtons.forEach((button) => {
        button.addEventListener('click', addKitToCart);
      });

      sync();
    });

    const mobileCards = cards.filter((card) => !card.dataset.kitMobileObserved);
    if (mobileCards.length > 0 && 'IntersectionObserver' in window) {
      const mobileBarObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('is-mobile-active', entry.isIntersecting);
        });
      }, { rootMargin: '-15% 0px -65% 0px' });

      mobileCards.forEach((card) => {
        card.dataset.kitMobileObserved = 'true';
        mobileBarObserver.observe(card);
      });
    } else if (mobileCards.length > 0) {
      mobileCards[0].dataset.kitMobileObserved = 'true';
      mobileCards[0].classList.add('is-mobile-active');
    }
  }

  function initProductSections() {
    document.querySelectorAll('[data-product-section]').forEach((section) => {
      initProductGallery(section);
      updateProductForm(section);
    });
  }

  function initTestimonialCarousels(root) {
    const scope = root || document;

    scope.querySelectorAll('[data-testimonial-carousel]').forEach((carousel) => {
      if (carousel.dataset.testimonialReady === 'true') return;

      const track = carousel.querySelector('[data-testimonial-track]');
      const previous = carousel.querySelector('[data-testimonial-prev]');
      const next = carousel.querySelector('[data-testimonial-next]');
      const slides = Array.from(carousel.querySelectorAll('[data-testimonial-slide]'));
      if (!track || slides.length === 0) return;

      carousel.dataset.testimonialReady = 'true';

      function slideStep() {
        const firstSlide = slides[0];
        const gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0');
        return firstSlide.getBoundingClientRect().width + gap;
      }

      function updateControls() {
        if (!previous || !next) return;

        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 1);
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      if (previous) {
        previous.addEventListener('click', () => {
          track.scrollBy({ left: -slideStep(), behavior: 'smooth' });
        });
      }

      if (next) {
        next.addEventListener('click', () => {
          track.scrollBy({ left: slideStep(), behavior: 'smooth' });
        });
      }

      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          updateControls();
          ticking = false;
        });
      });

      window.addEventListener('resize', updateControls);
      updateControls();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMobileMenu();
    initFaqs();
    initHeroVideos(document);
    initFilters();
    initCartDiscounts();
    initCartForms();
    initFindMyEnclosure();
    initKitPages();
    initProductSections();
    initTestimonialCarousels(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initHeroVideos(event.target);
    initKitPages(event.target);
    initTestimonialCarousels(event.target);
  });
})();
